<!-- eslint-disable vue/no-v-html -->
<template>
  <aside
    ref="sidebar"
    class="OSidebar admin"
    level="0"
    @mouseenter="debounce(50, handleMouseEnter, 'sideTime')()"
    @mouseleave="debounce(10, handleMouseLeave, 'sideTime')()"
  >
    <q-list class="Nv0-ul flex flex-col h-full !my-16" tag="ul">
      <MenuLi
        v-for="(Nv0, index) in menuAfterPermission"
        :key="Nv0.title + index"
        :data="Nv0"
        :sidebar="sidebar"
        :tag="Nv0.href ? 'a' : 'li'"
        :href="Nv0.href"
        :show-header="showHeader"
        :exact="true"
        class="text-white"
        @Nv0Click="() => handleClick(true)"
        @click="(e) => Nv0HandleClick(e, Nv0)"
        @click:close="onSubmenuClickClose"
      >
        <q-item-section v-if="Nv0.icon" avatar class="!pl-4">
          <div
            class="size-40 flex items-center justify-center p-8 rounded-md bg-white/10"
          >
            <q-icon
              class="size-24"
              :class="state.hover ? 'opacity-70' : 'opacity-60'"
              :name="Nv0.icon"
            />
          </div>
        </q-item-section>

        <q-item-section class="Nv0-text text-headline-2">
          <p class="one-line text-headline-2">
            {{ Nv0.title }}
          </p>
        </q-item-section>

        <q-item-section v-if="Nv0.submenu" avatar>
          <q-icon
            class="text-primary-pure"
            size="1.5rem"
            name="navigate_next"
          />
        </q-item-section>
      </MenuLi>
    </q-list>
    <MenuLogo />
  </aside>
</template>

<script setup>
import { closeMenu, state } from './MenuState'
import {
  computed,
  onMounted,
  onUnmounted,
  provide,
  ref,
  watch,
} from 'vue'
import { debounce } from 'js/utils/GLOBAL'
import { Screen } from 'quasar'
import { useRouter } from 'vue-router'
import MenuLi from './MenuLi.vue'
import MenuLogo from './MenuLogo.vue'

const router = useRouter()

const props = defineProps({
  menuList: {
    type: Array,
    default: () => [],
  },
})

const menuAfterPermission = computed(() => {
  return props.menuList.filter((i) => {
    if (!i.show) return false
    else return i
  })
  // return []
})

const pathTo = (i) => {
  const params = i?.params || {}
  const opts = i?.opts || {}

  return {
    ...i,
    ...params,
    ...opts,
  }
}

const showHeader = ref(true)

const sidebar = ref(null)

let $ = {}

onMounted(() => {
  $ = {
    Nv0: sidebar.value,
    body: document.body,
  }
  setTimeout(() => {
    state.value.passive = false
  }, 300)
})

watch(showHeader, () => {
  if (!showHeader.value) {
    $.body.classList.add('showHeader')
  } else {
    $.body.classList.remove('showHeader')
  }
})

watch(
  () => state.value.open,
  (open) => {
    if (open) {
      $.body.classList.add('sidebar-open')
    } else {
      $.body.classList.remove('sidebar-open')
      state.value.hover = false
      toggleActiveOnLis()
    }
  }
)

watch(
  () => state.value.hover,
  (hover) => {
    if (hover) {
      !Screen.lt.md && $.body.classList.add('sidebar-active')
    } else {
      $.body.classList.remove('sidebar-active')
    }
  }
)

onUnmounted(() => {
  state.value = {
    hover: false,
    open: false,
    passive: true,
  }
})

onMounted(() => {
  state.value.passive = false
})

function handleMouseEnter() {
  if (state.value.passive) return
  state.value.hover = true
  state.value.collapsed = false
}

function handleMouseLeave() {
  if (state.value.open || state.value.passive) return
  state.value.hover = false
  state.value.collapsed = true
}

function handleClick(val) {
  if (state.value.passive) return

  state.value.open = val
}

function onSubmenuClickClose() {
  setTimeout(() => {
    document
      .querySelectorAll('.Nv0-ul > li')
      .forEach((i) => i.classList.remove('active'))
    closeMenu()
  }, 100)
}

function Nv0HandleClick({ currentTarget }, Nv0) {
  // Se o item tem href externo
  if (Nv0.href) {
    debounce(0, handleClick, 'sideTime')(false)
    window.location.href = Nv0.href
    return
  }

  // Se o item tem name (rota interna) e não tem submenu, fecha o menu e navega
  if (Nv0.name && !Nv0.submenu) {
    closeMenu()
    router.push({ name: Nv0.name })
    return
  }

  toggleActiveOnLis(currentTarget)
}

function toggleActiveOnLis(current) {
  document
    .querySelectorAll('.Nv0-ul > li')
    .forEach((i) => i.classList.remove('active'))
  if (current) current.classList.toggle('active')
}

const emits = defineEmits(['click:botao-generico'])

provide('pathTo', pathTo)
provide('state', state)
</script>

<style lang="sass">
.OSidebar.admin
  background: #1E0644 !important
</style>
